var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { createAuthorizationHeaderValue } from 'utils/apis/axios';
import { authManager } from 'utils/auth/authManager';
import { elevioUrls, getBackendDomain, resolveElevioUrlByEnvironment, } from '../../../index';
const backendDomain = getBackendDomain();
const ELEVIO_DIXA_SSO_PATH = resolveElevioUrlByEnvironment({
    production: elevioUrls.production.sso,
    staging: elevioUrls.staging.sso,
}, backendDomain);
/** Queries Elevio API using a Dixa token, returns ElevioAuthTokenResponse */
export function fetchElevioAuthToken() {
    return __awaiter(this, void 0, void 0, function* () {
        const auth = yield authManager.getAuth();
        if (!auth)
            throw new Error('No auth data found');
        if (!auth.refresh_token)
            throw new Error('No refresh token found');
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: yield createAuthorizationHeaderValue(),
            },
        };
        const response = yield axios.post(ELEVIO_DIXA_SSO_PATH, {}, config);
        return {
            elevioToken: response.data.elevioToken,
        };
    });
}
